import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/AlertDialog";

import { ReactComponent as SpeechToText } from "assets/speech_to_text.svg";

import type { SessionTranscriptionDialogProps } from "./SessionTranscriptionDialog.types";

export default function SessionTranscriptionDialog({ open, setOpen }: SessionTranscriptionDialogProps) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="w-20 h-20 m-auto mb-5 rounded-full flex items-center justify-center bg-general-gray-200 border border-general-gray-400">
            <SpeechToText className="w-16 h-16 fill-general-gray-500" />
          </div>
          <AlertDialogTitle className="text-center">
            {t("session.sessionTranscriptionDialog.inProgress")}
          </AlertDialogTitle>
          <AlertDialogDescription className="sr-only">
            {t("session.sessionTranscriptionDialog.inProgress")}
          </AlertDialogDescription>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
}
